import styled from 'styled-components';

const Wrapper = styled.div`
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  position: relative;
  transform: rotate(0deg);
  transition: 0.5s ease-in-out;
  cursor: pointer;
`;

const Line = styled.span`
  display: block;
  position: absolute;
  background: ${(props) => props.color};
  border-radius: ${(props) => props.lineSize}px;
  height: ${(props) => props.lineSize}px;
  width: 100%;
  opacity: 1;
  left: 0;
  transform: rotate(0deg);
  transition: 0.25s ease-in-out;
`;

const FirstLine = styled(Line)`
  top: ${(props) => (props.opened ? `${props.lineSize * 2}px` : '0px')};
  width: ${(props) => (props.opened ? '0%' : null)};
  left: ${(props) => (props.opened ? '50%' : null)};
`;

const SecondLine = styled(Line)`
  top: ${(props) => props.lineSize * 2}px;
`;
const SecondLineLeft = styled(SecondLine)`
  transform: ${(props) => (props.opened ? 'rotate(45deg)' : null)};
`;
const SecondLineRight = styled(SecondLine)`
  transform: ${(props) => (props.opened ? 'rotate(-45deg)' : null)};
`;

const ThirdLine = styled(Line)`
  top: ${(props) =>
    props.opened ? `${props.lineSize * 2}px` : `${props.lineSize * 4}px`};
  width: ${(props) => (props.opened ? '0%' : null)};
  left: ${(props) => (props.opened ? '50%' : null)};
`;

type Props = {
  opened: boolean;
  color: string;
  size?: number;
};

const MenuIcon = ({ opened, color, size = 30 }: Props) => {
  const width = size;
  const height = size / 1.33;
  const lineSize = height / 5; // 3 lines, 2 spaces

  return (
    <Wrapper width={width} height={height}>
      <FirstLine opened={opened} color={color} lineSize={lineSize} />

      <SecondLineLeft opened={opened} color={color} lineSize={lineSize} />
      <SecondLineRight opened={opened} color={color} lineSize={lineSize} />

      <ThirdLine opened={opened} color={color} lineSize={lineSize} />
    </Wrapper>
  );
};

export default MenuIcon;
